module.exports = __webpack_public_path__ + "img/fanyi_grey.5a9a12b0.svg";